import { render, staticRenderFns } from "./cabnet-partnerdoctor.vue?vue&type=template&id=3dbe6bae&"
import script from "./cabnet-partnerdoctor.vue?vue&type=script&lang=js&"
export * from "./cabnet-partnerdoctor.vue?vue&type=script&lang=js&"
import style0 from "./cabnet-partnerdoctor.vue?vue&type=style&index=0&id=3dbe6bae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports